"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ManageAccessTableGenerator = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _config = _interopRequireDefault(require("./config"));
var _styles = _interopRequireDefault(require("./styles"));
var _utils = _interopRequireDefault(require("../utils"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Generate a Manage Access Table with the custom configuration
 * applied
 *
 * @param {object} [uiConfig]
 * @returns {object} { SearchBox }
 */
var ManageAccessTableGenerator = function ManageAccessTableGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.default;
  var functions = uiConfig.functions;
  var getOptions = functions && typeof functions.getOptions === 'function' ? functions.getOptions : _config.default.functions.getOptions;
  var getDefaultCustomFooter = functions && typeof functions.getDefaultCustomFooter === 'function' ? functions.getDefaultCustomFooter : _config.default.functions.getDefaultCustomFooter;
  var CustomDataTable = functions && functions.CustomDataTable ? functions.CustomDataTable : _config.default.functions.CustomDataTable;
  var ManageAccessTable = function ManageAccessTable(_ref) {
    var classes = _ref.classes,
      columns = _ref.columns,
      content = _ref.content,
      tableSpec = _ref.tableSpec;
    var loading = content.loading,
      error = content.error,
      data = content.data;
    var options = getOptions(tableSpec, classes, getDefaultCustomFooter);
    if (loading) {
      return /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null);
    }
    if (error) {
      return /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "h5",
        color: "error",
        size: "sm"
      }, error ? "An error has occurred in loading component: ".concat(error) : 'Recieved wrong data');
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 32
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(CustomDataTable, {
      data: data ? _utils.default.transformData(data.listUsers, tableSpec.columns) : [],
      columns: columns,
      options: options
    }))));
  };
  return {
    // @ts-ignore
    // eslint-disable-next-line max-len
    ManageAccessTable: (0, _core.withStyles)(_styles.default, {
      withTheme: true
    })(ManageAccessTable)
  };
};
exports.ManageAccessTableGenerator = ManageAccessTableGenerator;
var _default = ManageAccessTableGenerator;
exports.default = _default;